import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../contexts/ImagesContext';

export const LevelNumber = ({ value, top, left, height, width }) => {
  const { images } = useImagesContext();
  const imageTagList = [];
  for (let i = 0; i < value.length; i += 1) {
    const charector = value[i];
    imageTagList.push(
      <img
        style={{ height, position: 'relative' }}
        key={`level-${i}`}
        src={images[`level-${charector}.png`]}
        alt=""
      />,
    );
  }
  return (
    <Container top={top} left={left} width={width} height={height}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {imageTagList}
      </div>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  // border: 1px solid red;
`;
